"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PhoneInputValidator = _interopRequireDefault(require("../PhoneInput/PhoneInputValidator"));
var _EmailInputValidator = _interopRequireDefault(require("../EmailInput/EmailInputValidator"));
var _PhoneFormatter = _interopRequireDefault(require("../../common/Formatters/PhoneFormatter"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/document--download/24.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/launch/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.link.bx--link {\n  text-decoration: underline;\n  font-size: 14px;\n  display: inline-block;\n  line-height: 20px;\n  color: #000000; }\n  .link.bx--link:hover {\n    cursor: pointer; }\n  .link.bx--link:hover, .link.bx--link:active, .link.bx--link:active:visited {\n    color: #000000; }\n  .link.bx--link svg {\n    margin-top: 8px; }\n\n.link.with-lead-icon {\n  display: flex;\n  align-items: center; }\n  .link.with-lead-icon svg {\n    margin-top: unset;\n    margin-right: 0.5rem;\n    flex: 0 0 24px; }\n";
  const fileName = "Link_Link";
  const element = document.querySelector("style[data-sass-component='Link_Link']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Link = props => {
  const fixedCarbonProps = {
    className: ['link', props.withLeadIcon ? "with-lead-icon" : "", props.className].join(' ')
  };
  const getType = () => {
    if (props.type) {
      return props.type;
    }
    if (typeof props.target === 'string') {
      const isExternal = props.target.startsWith('http') || props.target.startsWith('www');
      if (isExternal) {
        return 'external';
      }
      if (parseHref().startsWith('data:')) {
        return 'download';
      }
    }
    return 'internal';
  };
  const isType = type => type === getType();
  const createDynamicCarbonProps = () => {
    if (typeof props.target === 'string') {
      const dynamicProps = {
        href: parseHref()
      };
      if (isType('external')) {
        dynamicProps.target = '_blank';
      }
      if (isType('download')) {
        if (!props.downloadName) {
          throw new Error('"downloadName" prop is required for a download link.');
        }
        dynamicProps.download = props.downloadName;
      }
      if (isType('internal')) {
        if (props.onClick) {
          dynamicProps.onClick = props.onClick;
        }
        dynamicProps.href = parseHref();
      }
      return dynamicProps;
    }
    if (typeof props.target === 'function') {
      return {
        onClick: props.target
      };
    }
  };
  const parseHref = () => {
    if (props.target.startsWith('JVBER')) {
      return `data:application/pdf;base64,${props.target}`;
    }
    if (_PhoneInputValidator.default.validatePattern(_PhoneFormatter.default.format(props.target))) {
      return `tel:${_PhoneFormatter.default.format(props.target)}`;
    }
    if (_EmailInputValidator.default.validatePattern(props.target)) {
      return `mailto:${props.target}`;
    }
    if (props.target.startsWith('www')) {
      return `http://${props.target}`;
    }
    return props.target;
  };
  const dynamicCarbonProps = createDynamicCarbonProps();
  const carbonProps = {
    ...fixedCarbonProps,
    ...dynamicCarbonProps
  };
  const renderIcon = () => {
    switch (getType()) {
      case 'internal':
        return /*#__PURE__*/_react.default.createElement(_.default, null);
      case 'external':
        return /*#__PURE__*/_react.default.createElement(_3.default, null);
      case 'download':
        return /*#__PURE__*/_react.default.createElement(_2.default, null);
      default:
        return;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Link, carbonProps, props.withLeadIcon && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderIcon()), props.children, props.withIcon && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), renderIcon()));
};
exports.Link = Link;
Link.propTypes = {
  target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  withIcon: _propTypes.default.bool,
  withLeadIcon: _propTypes.default.bool,
  downloadName: _propTypes.default.string
};
var _default = exports.default = Link;